import { render, staticRenderFns } from "./ProjectGroupDashboard.vue?vue&type=template&id=6e70bba9"
import script from "./ProjectGroupDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectGroupDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports